import {dd,store,app} from 'systems/imports'

//レイアウト調整処理
$(function(){
  //ヘッダー、フッターレイアウトを調整
  $(window).on("load resize", app.make("_").debounce(app.make("adjustLayout"),500))

  $(window).on("click",(e)=>{
    if(window.vm){
      window.vm.$data.lastWindowClick = (new Date()).getTime()
    }
  })
})



// WEBPACK FOOTER //
// ./src/systems/jquery.js